import { Modal, ProgressBar } from '../ui';

export interface ProgressModalProps {
    isOpen: boolean;
    progress: number;
    message: string;
}

export function ProgressModal({ isOpen, progress, message }: ProgressModalProps) {
    return (
        <Modal isOpen={isOpen} onClose={() => { }} size="md">
            <div className="text-center py-8">
                <h2 className="text-2xl font-bold mb-6">Genererer Video...</h2>

                <ProgressBar
                    progress={progress}
                    variant="gradient"
                    showPercentage
                    className="mb-4"
                />

                <p className="text-gray-400">{message}</p>

                {/* Loading Animation */}
                <div className="mt-8 flex items-center justify-center gap-2">
                    <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                    <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                    <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
                </div>
            </div>
        </Modal>
    );
}
